import React, { useEffect, useMemo ,useState} from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { UserProfileDropdown } from "./dropdowns/UserProfileDropdown";
import MultiCurrency from "./MultiCurrency";
import MultiLingual from "./MultiLingual";
import { Link } from "react-router-dom";
import axios from "axios";
import { NODE_API_URL } from "../../../../env_config";
import { useDispatch, useSelector } from "react-redux";
import { updateShortlistStoneCount } from "../../../../redux/commonRedux/common.actions";
import { FaShoppingCart } from "react-icons/fa";

export function QuickUserToggler(props) {   
  const userData = useMemo(()=>localStorage.getItem("userData"),[])
  const dispatch = useDispatch();
  const user = JSON.parse(userData)
  const [FullScreen,setFullScreen] = useState(false)  
  const [shortListedStone, setShortListedStone] = useState()  
  const uiService = useHtmlClassService();   
  const sessionId = localStorage.getItem("C_id");  

  const shortlistedStoneCount = useSelector((state) => {
    return state.ShortlistStoneReducer?.shortlistStoneCount;
  });

  const { hidePrice } = useSelector(
        (state) => state.CcModeSettingReducer
      );

  useEffect(() => {
    const config = {
      method: "GET",
      url: `${NODE_API_URL}/ccmode/get-cart-count?consumerId=${sessionId}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      },
    };

    axios(config).then((res) => {
      if(res.data.message === "UnAuthorized"){
        localStorage.clear();
        window.location.reload(true)
      }
      dispatch(
        updateShortlistStoneCount({ shortListedStoneCount: res.data.data })
      );

      setShortListedStone(res.data.data);
    });
  }, []);

  useEffect(() => {
    setShortListedStone(shortlistedStoneCount);
  }, [shortlistedStoneCount]);
  
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);

  function fullscreen() {
    const elem = document.documentElement;

    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        // Enter fullscreen
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen(); // Safari
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    } else {
        // Exit fullscreen
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen(); // Safari
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
}

document.addEventListener('fullscreenchange', exitHandler);
document.addEventListener('webkitfullscreenchange', exitHandler);
document.addEventListener('mozfullscreenchange', exitHandler);
document.addEventListener('MSFullscreenChange', exitHandler);

function exitHandler() {
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        setFullScreen(false);
    } else {
        setFullScreen(true);
    }
}
  return (
    <>
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-user-tooltip">View user</Tooltip>}
        >
          <div className="topbar-item">
            <div
              className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
              id="kt_quick_user_toggle"
            >
              <>
                <span className="symbol symbol-35 symbol-light-primary">
                  <span className="symbol-label font-size-h5 font-weight-bold">
                    {/* {user.fullname[0]} */}
                  </span>
                </span>
              </>
            </div>
          </div>
        </OverlayTrigger>
      )}
      <div className="d-none d-md-block">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-user-tooltip">{!FullScreen?"Enter Full Screen":"Exit Full Screen"}</Tooltip>}
        >
          <div className="topbar-item " onClick={() => fullscreen()}>
            <div
              className="btn btn-icon w-auto btn-clear d-flex align-items-center btn-sm mr-3"
            >
              <>
                  {!FullScreen?<i className="fas fa-expand text-primary"></i>:<i className="fas fa-solid fa-compress text-primary"></i>}
              </>
            </div>
          </div>
        </OverlayTrigger>
      </div>
      {hidePrice ? "" : <MultiCurrency themeData={props.themeData}/> }
      <MultiLingual themeData={props.themeData} translationsVersion={props.translationsVersion}/>
      <Link to="/shortlist" className="mx-2">
        <div className="symbol symbol-35 symbol-light-primary symbol-circle position-relative">
          <span className="symbol-badge symbol-badge-top small cart-symbol" >
            {shortListedStone}
          </span>
          <span className="symbol-label font-size-h5 font-weight-bold"><FaShoppingCart /></span>
        </div>
      </Link>  
      {!layoutProps.offcanvas && <UserProfileDropdown language={props.language} themeData={props.themeData}/>}  
    </>
  );
}
